import { useTheme } from "@mui/material/styles"
import { Handle } from "reactflow"

export default function CustomHandle({ position, type = "source", id, node }) {
  const theme = useTheme()
  return (
    <Handle
      position={position}
      type={type}
      id={id}
      isConnectable={node.isConnectable}
      style={{
        backgroundColor: "white",
        border: `1px solid ${theme.palette.colors.gray300}`,
        width: "8px",
        height: "8px",
      }}
    />
  )
}
